import { defineComponent as D, mergeModels as F, useModel as T, computed as R, useTemplateRef as C, ref as v, provide as W, watchEffect as X, watch as U, onMounted as j, nextTick as O, createElementBlock as x, openBlock as k, Fragment as q, createBlock as G, createElementVNode as m, resolveDynamicComponent as J, mergeProps as Q, unref as a, withCtx as d, normalizeClass as p, createVNode as f, renderSlot as Y, createCommentVNode as Z, createTextVNode as _, toDisplayString as ee, normalizeProps as ae, guardReactiveProps as le, useId as oe } from "vue";
import l from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Tabs/tabs.js";
import { classesFromBreakpointProps as K } from "../../breakpoints.js";
import { isElementInView as u } from "../../util.js";
import { useOUIAProps as te } from "../../helpers/ouia.js";
import { useEventListener as re, isDefined as ie } from "@vueuse/core";
import { provideChildrenTracker as ne } from "../../use/children-tracker.js";
import { TabsProvideKey as se, TabsKey as fe } from "./common.js";
import { AngleLeftIcon as de } from "../../packages/icons/dist/esm/icons/angle-left-icon.js";
import { AngleRightIcon as M } from "../../packages/icons/dist/esm/icons/angle-right-icon.js";
import P from "../Button.vue2.js";
import ue from "./TabTitleText.vue2.js";
import ce from "../../helpers/FloatingUi.vue2.js";
import ve from "../Menu/Menu.vue2.js";
import me from "../Menu/MenuContent.vue2.js";
import pe from "../Menu/MenuList.vue2.js";
const be = ["aria-expanded"], Ke = /* @__PURE__ */ D({
  name: "PfTabs",
  __name: "Tabs",
  props: /* @__PURE__ */ F({
    id: { default: () => oe() },
    defaultActiveKey: {},
    filled: { type: Boolean },
    subtab: { type: Boolean },
    secondary: { type: Boolean },
    box: { type: Boolean },
    vertical: { type: Boolean },
    noBorderBottom: { type: Boolean },
    backScrollAriaLabel: {},
    forwardScrollAriaLabel: {},
    component: { default: "div" },
    ariaLabel: {},
    mountOnEnter: { type: Boolean },
    unmountOnExit: { type: Boolean },
    pageInsets: { type: Boolean },
    defaultExpanded: { type: Boolean },
    overflowHorizontal: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean },
    inset: {},
    insetSm: {},
    insetMd: {},
    insetLg: {},
    insetXl: {},
    inset2xl: {},
    expandable: {},
    expandableSm: {},
    expandableMd: {},
    expandableLg: {},
    expandableXl: {},
    expandable2xl: {}
  }, {
    activeKey: {},
    activeKeyModifiers: {},
    expanded: { type: Boolean, default: void 0 },
    expandedModifiers: {}
  }),
  emits: ["update:activeKey", "update:expanded"],
  setup(g) {
    const s = g, V = te({ id: s.ouiaId, safe: s.ouiaSafe }), E = T(g, "activeKey"), b = R({
      get: () => E.value ?? s.defaultActiveKey,
      set: (e) => {
        E.value = e;
      }
    }), c = T(g, "expanded"), o = C("tabList"), h = C("tabMore"), $ = v(), S = v(), A = v(), n = ne(fe);
    W(se, {
      secondary: s.secondary,
      activeKey: b,
      idSuffix: () => s.id,
      tabOverflowRef: $,
      contentTargetRef: S
    });
    const I = v(!1), w = v(!1), B = v(!1), L = R(() => n.reduce((e, r) => e + (r.overflowing ? 1 : 0), 0));
    s.vertical || re("resize", y, !1), X(() => {
      (!ie(b.value) || !n.find((e) => e.key === b.value)) && n.length && (b.value = n[0].key);
    }), U(n, y, { immediate: !0 }), j(() => {
      O(y);
    });
    function z() {
      var r;
      if (!o.value || !((r = n[0]) != null && r.el) || !u(o.value, n[0].el, !1))
        return;
      let e = !1;
      for (const t of n)
        !t.overflowing && t.el && !u(o.value, t.el, !1) && (t.overflowing = !0, e = !0);
      e && O(() => {
        if (o.value && h.value && n.length > 0 && !u(o.value, h.value, !1))
          for (let t = n.length - 1; t >= 0; t--) {
            const i = n[t];
            if (!i.overflowing) {
              i.overflowing = !0;
              return;
            }
          }
      });
    }
    function y() {
      if (!o.value || s.vertical)
        return;
      if (s.overflowHorizontal) {
        z();
        return;
      }
      const e = !u(o.value, o.value.firstElementChild, !1);
      w.value = !e;
      const r = !u(o.value, o.value.lastElementChild, !1);
      B.value = !r, I.value = e || r;
    }
    function H() {
      if (!o.value)
        return;
      const e = Array.from(o.value.children);
      let r, t, i;
      for (i = 0; i < e.length && !r; i++)
        if (u(o.value, e[i], !1)) {
          r = e[i], t = e[i - 1];
          break;
        }
      t && (o.value.scrollLeft -= t.scrollWidth);
    }
    function N() {
      if (!o.value)
        return;
      const e = Array.from(o.value.children);
      let r, t;
      for (let i = e.length - 1; i >= 0 && !r; i--)
        if (u(o.value, e[i], !1)) {
          r = e[i], t = e[i + 1];
          break;
        }
      t && (o.value.scrollLeft += t.scrollWidth);
    }
    return (e, r) => (k(), x(q, null, [
      (k(), G(J(e.component), Q(a(V), {
        id: e.id,
        "aria-label": e.ariaLabel,
        class: [
          a(l).tabs,
          a(K)(s, ["inset"], a(l)),
          e.vertical && e.expandable && a(K)(s, ["expandable"], a(l), { short: !0 }),
          {
            [a(l).modifiers.fill]: e.filled,
            [a(l).modifiers.subtab]: e.subtab,
            [a(l).modifiers.vertical]: e.vertical,
            [a(l).modifiers.expanded]: e.vertical && e.expandable && (c.value ?? e.defaultExpanded),
            [a(l).modifiers.box]: e.box,
            [a(l).modifiers.scrollable]: I.value,
            [a(l).modifiers.pageInsets]: e.pageInsets,
            [a(l).modifiers.noBorderBottom]: e.noBorderBottom,
            [a(l).modifiers.secondary]: e.secondary,
            [a(l).modifiers.overflow]: e.overflowHorizontal && L.value > 0
          }
        ]
      }), {
        default: d(() => [
          m("div", {
            class: p(a(l).tabsScrollButton)
          }, [
            f(P, {
              variant: "plain",
              disabled: w.value,
              "aria-label": e.backScrollAriaLabel,
              "aria-hidden": w.value,
              onClick: H
            }, {
              default: d(() => [
                f(a(de))
              ]),
              _: 1
            }, 8, ["disabled", "aria-label", "aria-hidden"])
          ], 2),
          m("ul", {
            ref: "tabList",
            role: "tablist",
            class: p(a(l).tabsList),
            onScrollPassive: y
          }, [
            Y(e.$slots, "default"),
            e.overflowHorizontal && L.value > 0 ? (k(), x("li", {
              key: 0,
              ref: "tabMore",
              class: p([a(l).tabsItem, a(l).modifiers.overflow]),
              role: "presentation"
            }, [
              m("button", {
                ref_key: "overflowTabRef",
                ref: A,
                type: "button",
                class: p([a(l).tabsLink, { [a(l).modifiers.expanded]: c.value ?? e.defaultExpanded }]),
                "aria-haspopup": "menu",
                "aria-expanded": c.value ?? e.defaultExpanded,
                role: "tab",
                onClick: r[0] || (r[0] = (t) => c.value = !c.value)
              }, [
                f(ue, null, {
                  default: d(() => [
                    _(" More (" + ee(L.value) + ") ", 1)
                  ]),
                  _: 1
                }),
                m("span", {
                  class: p(a(l).tabsLinkToggleIcon)
                }, [
                  f(a(M))
                ], 2)
              ], 10, be),
              f(ce, {
                hidden: !(c.value ?? e.defaultExpanded),
                "teleport-to": a(h),
                reference: A.value
              }, {
                default: d(() => [
                  f(ve, ae(le(e.$attrs)), {
                    default: d(() => [
                      f(me, null, {
                        default: d(() => [
                          f(pe, { ref: "tabOverflow" }, null, 512)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 16)
                ]),
                _: 1
              }, 8, ["hidden", "teleport-to", "reference"])
            ], 2)) : Z("", !0)
          ], 34),
          m("div", {
            class: p(a(l).tabsScrollButton)
          }, [
            f(P, {
              variant: "plain",
              disabled: B.value,
              "aria-label": e.forwardScrollAriaLabel,
              "aria-hidden": B.value,
              onClick: N
            }, {
              default: d(() => [
                f(a(M))
              ]),
              _: 1
            }, 8, ["disabled", "aria-label", "aria-hidden"])
          ], 2)
        ]),
        _: 3
      }, 16, ["id", "aria-label", "class"])),
      m("div", {
        ref_key: "contentTargetRef",
        ref: S
      }, null, 512)
    ], 64));
  }
});
export {
  Ke as default
};
